export default {"src":"/_next/static/media/close.b7a301b9.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};